import { render, staticRenderFns } from "./event-distribution.vue?vue&type=template&id=1f34b239&"
import script from "./event-distribution.vue?vue&type=script&lang=js&"
export * from "./event-distribution.vue?vue&type=script&lang=js&"
import style0 from "./event-distribution.vue?vue&type=style&index=0&id=1f34b239&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports